import ManagerPage from "./pages/ManagerPage";

export default ManagerPage;
